<template>
    <div class="section-tab-wrap">
        <div class="section-tab">
            <div
                v-for="(item, index) in list"
                :key="index"
                class="section-tab-item"
                v-bind:class="{'active': active === item.id }"
                @click="handleTabChange(item)"
                >{{item.name}}</div>
        </div>
        <div class="section-tab-line"></div>
    </div>
</template>
<script>
export default {
    name: 'SectionTab',
    props: ['list', 'active'],
    methods: {
        handleTabChange(item) {
            this.$emit('handleTabChange', item)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.section-tab-wrap {
    position: relative;
    height: .5rem;
    .section-tab-line {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-bottom: 1px solid $grey_border_color_e0;
        z-index: 0;
    }
}
.section-tab {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 0 .2rem;
    .section-tab-item {
        padding: 0 .06rem;
        font-size: .14rem;
        color: $font_color_A6;
        border-bottom: 1px solid transparent;
        line-height: .49rem;
        cursor: pointer;
        &.active {
            color: $font_color_51b;
            border-color: $font_color_51b;
        }
        & + .section-tab-item {
            margin-left: .18rem;
        }
    }
}
</style>